/* global gsap */

import React from 'react'
import PropTypes from 'prop-types'
import CompareCollapse from '../../../2_Molecules/Collapse/CompareCollapse'
//import TrimSpecTable from './TrimSpecTable/TrimSpecTable'
import { useMediaQuery } from '../../../../hooks/useMediaQuery'
import ReactHtmlParser from 'react-html-parser';

const getTableDataCellValue = (trimData, category, name, index) => {
  try {
    const categoryData = trimData[category];

    if (categoryData) {
      // DEPRECATED! Do not use the "NAME" anymore as we have some data that have twice the same name "AWD"
      // return categoryData.find(item => item.Title === name);
      return categoryData.at(index);
    }

    return null
  } catch (err) {
    console.log(err);
  }
}

const generateTableRow = (name, values, isHeaderCell, catCount) => {
  if( isHeaderCell){
    return (
          <tr role="row" className={`compare_body mz-table-content ${catCount===1 ? '' : ''}`} data-row-target={'row_' + catCount}>
            <td className="mz-table-left" role="cell">
              {ReactHtmlParser(name)}
            </td>
          </tr>
    )
  }else{
    return (
        <>
          <tr role="row" className={`mz-table-mobile mz-table-content ${catCount===1 ? '' : ''}`} data-row-target={'row_' + catCount}>
            <td role="cell">
              {ReactHtmlParser(name)}
            </td>
          </tr>
          <tr className={`mz-table-content ${catCount===1 ? '' : ''}`}  data-row-target={'row_' + catCount}>
            <td className="mz-table-left mz-table-300 mz-table-tablet-200 mz-table-mobile-150 ">{ReactHtmlParser(name)}</td> 
            {values.map((value, index) =>
              {
                if(index===0){
                  return (<td key={`${name}-${index}`} className="mz-table-col--selected text--center mz-table-250 mz-table-tablet-150 mz-table-mobile-150">{ReactHtmlParser(value)}</td>)
                }else{
                  return (<td key={`${name}-${index}`} className="text--center mz-table-250 mz-table-tablet-150 mz-table-mobile-150">{ReactHtmlParser(value)}</td>)
                }
              }
            )}
          </tr>
        </>
    )
  }
}

function triggerAccordion(e){
  const isExpanded = e.target.classList.contains('active')
  const rowList = e.target.closest('table').querySelectorAll('[data-row-target]')
  rowList.forEach((current, index, array) =>{
    current.classList.remove('active');
  });
  const buttonList = e.target.closest('table').querySelectorAll('button')
  buttonList.forEach((current, index, array) =>{
      current.classList.remove('active');
  });

  if(!isExpanded){
    e.target.classList.add('active');
    const activeRowList = e.target.closest('table').querySelectorAll(`[data-row-target="${e.target.closest('tr').getAttribute('id')}"]`)
    activeRowList.forEach((current, index, array) =>{
      current.classList.add('active');
      gsap.to(e.target.closest('.mz-table-container'), {
        delay: .5,
        duration: .5,
        scrollTo: { x: 0, y: e.target, offsetY: e.target.closest('table').querySelector('thead').clientHeight + 10}
      });
      document.body.scrollTo(0,0);
    });
  }
}
function TrimSpecAccordions({ modelData, trimsOrder, activeSlide }) {
  const currentMQ = useMediaQuery();
  const isMobile = ['xs', 'sm'].includes(currentMQ);

  const firstColumnData = isMobile ? modelData[trimsOrder[activeSlide]] : modelData[trimsOrder[0]];
  const firstColumnSpecData = firstColumnData?.specifications;

  let catCount = 0;

  const generateTableAccordions = (categoryName, categoryData) => {
    catCount++

    // Generate the table rows of the category.
    const tableRows = categoryData.map((item, itemIndex) => {
      let tabelData = [item.Data];

      //if (!isMobile) {
        // Get the all the data-cell values in the row.
        trimsOrder.forEach((trimCode, index) => {
          if (index !== 0) {
            const trimData = modelData[trimCode]?.specifications;
            const trimRowData = getTableDataCellValue(trimData, categoryName, item.Title, itemIndex);

            if (trimRowData && trimRowData.Data) {
              tabelData = [...tabelData, trimRowData.Data];
            }
          }
        })
      //}

      const isHeaderCell = (item.type && item.type.toLowerCase() === 'header');
      return generateTableRow(item.Title, tabelData, isHeaderCell, catCount);
    })

    return (
      <CompareCollapse
        key={categoryName}
        id={catCount}
        isActive={false}
        onClick={triggerAccordion}
        buttonContent={(<h6>{categoryName}</h6>)}
      >
        {tableRows}
      </CompareCollapse>
    )
  }

  return (
    <tbody className="mz-trim-spec-accordions">
      {
        (firstColumnData && firstColumnSpecData) && (
          Object.keys(firstColumnSpecData).map(categoryName => {
            return generateTableAccordions(categoryName, firstColumnSpecData[categoryName])
          })
        )
      }
    </tbody>
  )
}

TrimSpecAccordions.propTypes = {
  modelData: PropTypes.object.isRequired,
  trimsOrder: PropTypes.array.isRequired,
  activeSlide: PropTypes.number.isRequired,
}

export default TrimSpecAccordions